<template>
  <v-container fluid>
    <v-row align="center" justify="center">
      <v-col md="6" align="center" justify="center">
        <div width="650px" style="padding: 10px">
          <!-- HEADER SECTION -->

          <v-row
            class="justify-center align-center text-center"
            style="max-width: 650px"
          >
            <v-col class="text-left">
              <img :src="client_logo" style="width: 125%" />
            </v-col>
            <v-col md="8">
              <div>
                <h3>Verify Your Dependents with Documents</h3>
                <p>Follow the steps below to verify each of your dependents.</p>
              </div>
            </v-col>
            <v-col class="text-right">
              <a href="#" @click="Logout()">Logout</a>
            </v-col>
          </v-row>

          <br />

          <!-- SELECT DEPENDENT OPTION -->

          <div class="flex-wrapper section-wrapper">
            <div class="flex-size">
              <p style="font-weight: bold">
                Step 1: Select a Dependent To Verify
              </p>
              <p style="font-size: 12px">
                You have {{ Lst_Dependent.length }}
                <span v-if="Lst_Dependent.length > 1"> dependents</span
                ><span v-else>dependent</span> to verify
              </p>
            </div>
            <div class="flex-size">
              <v-select
                label="Dependent"
                v-model="selDependent"
                :items="Lst_Dependent"
                item-value="DEPENDENT_SEQUENCE_NO"
                item-text="FULLNAME"
                dense
                outlined
                hide-details
                return-object
                clearable
                @change="selected_dependent"
              >
                <template slot="item" slot-scope="data">
                  {{ data.item.FULLNAME }}
                </template>
              </v-select>
            </div>
          </div>

          <!-- SELECT OR SCAN DOCUMENTS -->
          <div class="flex-wrapper section-wrapper">
            <div class="flex-size">
              <p style="font-weight: bold">
                Step 2: Click <a href="#" @click="Step2_Clicked()">here</a> to
                view the Eligibility Rules & Required Dependent Verification
                Documentation
              </p>
            </div>
          </div>

          <!-- SELECT OR SCAN DOCUMENTS -->
          <div class="flex-wrapper section-wrapper">
            <div class="flex-size">
              <p style="font-weight: bold">
                Step 3:
                <span v-if="selDependent == null || selDependent == ''"
                  >Upload Documents</span
                ><span v-else
                  >Upload Document's for {{ dep_first_name }} below</span
                >
              </p>
            </div>
          </div>

          <v-card max-width="650px" elevation="0">
            <v-row md="10" sm="12">
              <v-col class="text-left">
                <v-btn
                  style="
                    background-color: #005c84;
                    border-radius: 10px !important;
                  "
                  small
                  dense
                  class="text-none white--text"
                  @click="onButtonClick"
                  :disabled="!(selDependent && selDependent != null)"
                >
                  Browse File
                </v-btn>
                <input
                  ref="uploader"
                  id="uploader"
                  class="d-none"
                  type="file"
                  multiple="multiple"
                  accept="image/*,application/pdf"
                  @change="onFileChanged"
                />
              </v-col>
              <v-col>
                <v-btn
                  style="
                    background-color: white;
                    border-radius: 10px !important;
                    margin-right: 30px;
                  "
                  class="text-none black--text"
                  small
                  dense
                  @click="Clear()"
                >
                  Clear
                </v-btn>
              </v-col>
              <v-col class="text-right">
                <v-btn
                  style="
                    background-color: #005c84;
                    border-radius: 10px !important;
                    width: 140px;
                  "
                  class="text-none white--text"
                  dense
                  small
                  @click="Save_Close_2()"
                  :disabled="ValidateFiles"
                >
                  Upload
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <!--  List of Uploaded Docs -->
          <v-row class="primary pa-0 ma-0 my-2 mt-5" style="max-width: 650px">
            <v-col class="text-left white--text py-1"> Uploaded Files</v-col>
          </v-row>
          <v-card
            md="10"
            sm="12"
            dense
            elevation="5"
            max-width="650px"
            class="pa-3 mt-2"
            height="150px"
            style="overflow-y: scroll; top: -6px"
          >
            <table
              width="100%"
              style="font-family: Open Sans, sans-serif; font-size: 80%"
            >
              <template v-for="(item, index) in dep_doc_list">
                <tr :key="index">
                  <td align="left" width="25px">
                    <div style="width: 25px">
                      <img src="pdf.png" />
                    </div>
                  </td>
                  <td width="400px" align="left">
                    <div
                      style="width: 400px"
                      v-if="item.DOC_FILENAME.length <= 100"
                    >
                      {{ item.DOC_FILENAME }}
                    </div>
                    <div style="width: 400px" v-else>
                      <v-tooltip max-width="400" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{
                            formatFileName(item.DOC_FILENAME)
                          }}</span>
                        </template>
                        {{ item.DOC_FILENAME }}
                      </v-tooltip>
                    </div>
                  </td>

                  <td width="30px" align="left">
                    <div style="width: 30px">
                      <a @click="viewFile_UploadedDoc(item.RECORD_ID)">View</a>
                    </div>
                  </td>
                </tr>
              </template>
            </table>
          </v-card>

          <!--  Browse file mode list section-->
          <v-row class="primary pa-0 ma-0 my-2 mt-2" style="max-width: 650px">
            <v-col class="text-left white--text py-1"> Ready for Upload</v-col>
          </v-row>
          <v-card
            md="10"
            sm="12"
            dense
            elevation="5"
            max-width="650px"
            class="pa-3 mt-2"
            height="150px"
            style="overflow-y: scroll; top: -6px"
          >
            <table
              width="100%"
              style="font-family: Open Sans, sans-serif; font-size: 80%"
            >
              <template v-for="(item, index) in lst_file">
                <tr :key="index">
                  <td align="left" width="25px">
                    <div style="width: 25px">
                      <span v-if="item.type.includes('pdf')"
                        ><img src="pdf.png" /></span
                      ><span v-else><img src="img.png" /></span>
                    </div>
                  </td>
                  <td width="120px" align="left">
                    <div style="width: 120px" v-if="item.name.length <= 30">
                      {{ item.name }}
                    </div>
                    <div style="width: 120px" v-else>
                      <v-tooltip max-width="400" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">{{
                            formatFileName(item.name)
                          }}</span>
                        </template>
                        {{ item.name }}
                      </v-tooltip>
                    </div>
                  </td>
                  <!-- <td align="right" width="60px">
                      {{ item.size_string }}
                    </td> -->

                  <td align="left" style="white-space: nowrap; width: 150px">
                    <div style="max-width: 150px !important">
                      <v-select
                        v-model="item.doc_type"
                        item-text="TITLE"
                        item-value="RECORD_ID"
                        outlined
                        label=""
                        placeholder="Document Type"
                        hide-details
                        dense
                        :rules="formRules.lst_file"
                        :items="lst_doc_type"
                      ></v-select>
                    </div>
                  </td>
                  <td width="50px" align="left">
                    <div style="width: 50px">
                      <a @click="RemoveFile(index)">Remove</a>
                    </div>
                  </td>
                  <td width="30px" align="left">
                    <div style="width: 30px">
                      <a @click="viewFile(index)">View</a>
                    </div>
                  </td>
                </tr>
              </template>
            </table>
          </v-card>
        </div>

        <v-overlay :absolute="true" :value="loading">
          <div style="text-align: center">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
          </div>
        </v-overlay>
        <div class="text-center"></div>
      </v-col>
    </v-row>
    <!-- display guideline -->
    <v-dialog v-model="dgDisplayGuide" persistent width="1200px">
      <v-card class="pa-0 ma-0 overflow-hidden" height="100%">
        <v-toolbar height="30" headline grey lighten-2>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="black"
            size="x-small"
            elevation="0"
            @click="
              dgDisplayGuide = false;
              selectedDocURL = null;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="width: 100%x; height: 680px">
          <iframe
            :src="selectedDocURL"
            style="width: 100%; height: 100%; border: none"
          >
          </iframe>
        </div>
      </v-card>
    </v-dialog>

    <!-- Display Uploaded File -->
    <v-dialog v-model="dgDisplayUploadFile" persistent width="1200px">
      <v-card class="pa-0 ma-0 overflow-hidden" height="100%">
        <v-toolbar height="30" headline grey lighten-2>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="black"
            size="x-small"
            elevation="0"
            @click="
              dgDisplayUploadFile = false;
              selectedDocURL = null;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div style="width: 100%x; height: 680px">
          <iframe
            :src="selectedDocURL"
            style="width: 100%; height: 100%; border: none"
          >
          </iframe>
        </div>
      </v-card>
    </v-dialog>

    <!-- display file -->
    <v-dialog v-model="dgDisplayFile" persistent width="1200px">
      <!-- <v-btn
              class="close-popup"
              icon
              color="black"
              size="x-small"
              elevation="0"
              @click="
                dgDisplayFile = false;
                selectedDocURL = null;
              "
            >
              <v-icon>mdi-close-thick</v-icon>
            </v-btn> -->
      <v-card class="pa-0 ma-0 overflow-hidden" height="100%">
        <v-toolbar height="30" headline grey lighten-2>
          <v-toolbar-title></v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn
            icon
            color="black"
            size="x-small"
            elevation="0"
            @click="
              dgDisplayFile = false;
              selectedDocURL = null;
            "
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>

        <div
          style="
            width: 100%x;
            height: 680px;
            over-flow: auto;
            position: relative;
          "
          v-if="selectedDocType && selectedDocType.includes('image')"
        >
          <img
            :src="selectedDocURL"
            style="
              max-height: 100%;
              max-width: 100%;
              width: auto;
              height: auto;
              position: absolute;
              top: 0;
              bottom: 0;
              left: 0;
              right: 0;
              margin: auto;
            "
          />
        </div>
        <div
          style="width: 100%x; height: 680px"
          v-else-if="selectedDocType && selectedDocType.includes('pdf')"
        >
          <iframe
            :src="selectedDocURL"
            style="width: 100%; height: 100%; border: none"
          >
          </iframe>
          <!-- <object
            type="application/pdf"
            :data="selectedDocURL"
            width="100%"
            height="100%"
          ></object> -->
        </div>

        <!-- <v-btn
                    color="primary"
                    @click="
                      dgDisplayFile = false;
                      selectedDocURL = null;
                    "
                  >
                    Close
                  </v-btn> -->
      </v-card>
    </v-dialog>

    <v-dialog v-model="dgConfirm" persistent width="500">
      <v-card>
        <v-toolbar class="headline grey lighten-2" height="40px">
          <v-card-title> Documents Upload </v-card-title>
        </v-toolbar>

        <v-card-text>
          <br />
          CONGRATULATIONS, Your documents have been saved successfully!
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-none"
            style="border-radius: 10px !important"
            @click="dgConfirm = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dgConfirmLimit" persistent width="500">
      <v-card>
        <v-toolbar class="headline grey lighten-2" height="40px">
          <v-card-title> Documents </v-card-title>
        </v-toolbar>

        <v-card-text>
          <br />
          You have reach the maximum number of upload documents.
        </v-card-text>
        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="text-none"
            style="border-radius: 10px !important"
            @click="dgConfirmLimit = false"
          >
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  name: "App",
  components: {},
  data: () => ({
    dgDisplayUploadFile: false,
    Remove_Confirm: false,
    Msg: null,
    dgMsg: false,

    UserInfo: null,
    dgDisplayGuide: false,

    Emp_FirstName: null,
    Emp_LastName: null,
    Emp_Middle: null,
    Master_Acct_Name: null,
    Master_Acct_Number: 55,
    Account_Name: null,
    Account_Number: null,
    Emp_Number: null,
    COBRA_Status: null,
    Has_MED: 0,
    Has_Dep_FSA_Acct: 0,

    Lst_Dependent: [],
    selDependent: null,

    lst_file: [],
    file_object: null,
    selectedFile: null,
    img: null,
    selectedDocURL: null,
    selectedDocType: null,
    dgConfirmLimit: false,
    dgConfirm: false,
    currentUploadFile: null,
    dgDisplayFile: false,
    lst_doc_type: [],
    loading: false,
    dep_first_name: null,
    dep_doc_list: [],
    dep_no: 0,

    formRules: {
      lst_file: [(value) => !!value || "Required."],
      Dependent: [(value) => !!value || "Required."],
    },
  }),

  created() {},

  mounted() {
    if (this.rcapt_token == null || this.rcapt_token == "")
      this.$router.push({ name: "home" });
    else this.init();
  },

  /*  mounted() {
    this.init();
  }, */

  methods: {
    Step2_Clicked() {
      var self = this;
      if (self.Account_Number) {
        const first7Chars = self.Account_Number.slice(0, 7);
        self.selectedDocURL = "./guide/" + first7Chars + ".pdf";
        self.dgDisplayGuide = true;
      } else self.selectedDocURL = null;
    },

    Logout() {
      this.$router.push({ name: "home" });
    },

    selected_dependent: async function (sel) {
      this.loading = true;
      if (sel) {
        this.lst_file.forEach((element) => {
          element.doc_type = "";
        });
        this.dep_first_name = sel.FIRST_NAME;
        this.dep_no = sel.DEPENDENT_SEQUENCE_NO;
        await this.GetDepDocList();
        await this.GetDocTypeList(sel.ACCOUNT_NUMBER, sel.RELATIONSHIP_CODE);
      } else {
        this.dep_first_name = "";
        this.dep_no = 0;
        this.dep_doc_list = [];
      }
      this.loading = false;
    },

    clickOK() {
      this.$router.push({ name: "home" });
    },

    formatFileName(filename) {
      if (filename.length > 30) {
        var f = filename.substring(0, 30);
        var re = new RegExp("[^.]+$");
        var ext = filename.match(re);

        return f + "..." + ext;
      } else return filename;
    },

    formatBytes(bytes) {
      const scale = 1024;
      const orders = ["GB", "MB", "KB", "Bytes"];
      let max = Math.pow(scale, orders.length - 1);

      for (const order of orders) {
        if (bytes > max) {
          return `${(bytes / max).toFixed(2)} ${order}`;
        }
        max /= scale;
      }

      return "0 Bytes";
    },

    RemoveFile(index) {
      this.lst_file.splice(index, 1);
    },

    viewFile_UploadedDoc: async function (record_id) {
      await this.GetFile(record_id);
    },

    getFileExtension: async function (filename) {
      const lastIndex = filename.lastIndexOf(".");
      if (lastIndex === -1) {
        return ""; // No extension found
      }
      return filename.slice(lastIndex + 1);
    },

    GetFile: async function (record_id) {
      var self = this;
      self.dgDisplayUploadFile = true;
      await axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/GetFile", {
          record_id: record_id,
        })
        .then(async (r) => {
          var dt = JSON.parse(r.data.d);
          var fileExt = await self.getFileExtension(dt[0].file_name);
          var binaryString = window.atob(dt[0].base64_string);
          var binaryLen = binaryString.length;
          var bytes = new Uint8Array(binaryLen);
          for (var i = 0; i < binaryLen; i++) {
            var ascii = binaryString.charCodeAt(i);
            bytes[i] = ascii;
          }
          var blob;
          if (fileExt.toLowerCase() == "pdf") {
            blob = new Blob([bytes], { type: "application/pdf" });
          } else {
            blob = new Blob([bytes], { type: "image/jpg" });
          }
          var url = window.URL || window.webkitURL;
          var link = url.createObjectURL(blob);
          self.selectedDocURL = link;
        })
        .catch(() => {});
    },

    viewFile(index) {
      var self = this;
      self.dgDisplayFile = true;
      var file = this.lst_file[index];

      var url = file.base64_string;

      var blobUrl;
      var blob;

      fetch(url)
        .then((res) => res.blob())
        .then((ret) => {
          blob = ret;
        })
        .then(() => {
          blobUrl = URL.createObjectURL(blob);
          self.selectedDocURL = blobUrl; // file.base64_string;
          self.selectedDocType = file.type;
        });
    },

    onButtonClick() {
      this.isSelecting = true;
      window.addEventListener(
        "focus",
        () => {
          this.isSelecting = false;
        },
        { once: true }
      );

      this.$refs.uploader.click();
    },

    onFileChanged: async function (e) {
      if (this.lst_file && this.lst_file.length + e.target.files.length > 10)
        this.dgConfirmLimit = true;
      else {
        for (var i = 0; i < e.target.files.length; i++) {
          this.selectedFile = e.target.files[i];

          if (this.selectedFile) {
            if (
              this.selectedFile.type.includes("image") ||
              this.selectedFile.type.includes("pdf")
            ) {
              await this.getBin(this.selectedFile);
              document.getElementById("uploader").value = "";
            }
          }
        }
      }
    },

    getBin: async function (img) {
      var self = this;

      var reader = new FileReader();
      var ff = async () => {
        reader.onloadend = async () => {
          var b = new Object();
          b.name = img.name;
          b.size = img.size;
          b.size_string = self.formatBytes(img.size);
          b.base64_string = reader.result;
          b.type = img.type;
          b.doc_type = "";
          self.lst_file.push(b);
          self.img = null;
        };
        reader.readAsDataURL(img);
      };
      await ff();
    },

    GetDocTypeList: async function (account_number, relation_code) {
      var self = this;
      await axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/GetDocTypeList", {
          account_number: account_number,
          relation_code: relation_code,
        })
        .then((r) => {
          self.lst_doc_type = JSON.parse(r.data.d);
        })
        .catch(() => {
          self.lst_doc_type = [];
        });
    },

    Get_Settings: async function () {
      var self = this;
      var url = self.methodUrl + "/depdoc/WebService.asmx/Get_Settings";
      var result = null;
      await axios
        .post(url, {})
        .then(async (r) => {
          result = JSON.parse(r.data.d);
          if (result) {
            self.selScanner = result.SETTING_SCANNER;
            self.selCategory = self.Lst_Category.find(
              (i) => i.CD_CODE == result.SETTING_DOC_CATEGORY
            );
            await self.Get_Category_Item(self.selCategory.CD_CODE);
            self.selCategoryItem = self.Lst_Category_Item.find(
              (i) => i.CD_CODE == result.SETTING_CATEGORY_ITEM
            );
          }
        })
        .catch(() => {
          result = null;
        });
      return result;
    },

    Device_Changed: async function () {
      var self = this;
      if (self.selScanner) {
        await self.DWObject.SelectDeviceAsync(self.selScanner);

        if (self.selScanner.displayName.indexOf("WIA-") == 0) {
          self.showScanUI = false;
          self.ScanUI = true;
        } else {
          self.ScanUI = false;
        }
      }
    },

    Save_Close_2: async function () {
      var self = this;

      self.loading = true;

      var r = await self.Test_Save();
      if (r == 1) {
        self.dgConfirm = true;
        self.currentUploadFile = null;
      }

      self.Clear();
      self.GetDepDocList();

      self.loading = false;
    },

    async f1(base64Data, file_name, file_type) {
      const base64 = await fetch(base64Data);
      const blob = await base64.blob();
      const file = new File([blob], file_name, { type: file_type });
      return file;
    },

    async Test_Save() {
      var self = this;

      var hid = self.selDependent.RECORD_ID;
      for (var i = 0; i < self.lst_file.length; i++) {
        let formData = new FormData();
        var base64Data = self.lst_file[i].base64_string;
        var file_type = self.lst_file[i].type;
        var file_name = self.lst_file[i].name;
        var doc_type = self.lst_file[i].doc_type;
        var file = await self.f1(base64Data, file_name, file_type);
        formData.append("hid", hid);
        formData.append("doc_type", doc_type);
        formData.append(file_name, file);
        self.currentUploadFile = file_name;
        await self.Test_UploadFiles(formData);
        //await self.UpdateDepUploadStatus(hid, 1);
        await self.Get_Dependent_List(self.employee_number);
        self.selDependent = null;
      }
      return 1;
    },

    async Test_UploadFiles(f) {
      var self = this;

      await axios
        .post(self.methodUrl + "/depdoc/myFileUpload.ashx", f, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then(() => {})
        .catch(() => {});
    },

    UpdateDepUploadStatus: async function (dep_rec_id, uploaded) {
      var self = this;

      await axios
        .post(
          self.methodUrl + "/depdoc/WebService.asmx/UpdateDepUploadStatus",
          { dep_rec_id: dep_rec_id, uploaded: uploaded }
        )
        .then(() => {})
        .catch(() => {});
    },

    Save_Close: async function () {
      var self = this;

      if (self.selCategory && self.selCategory.CD_CODE == 20) {
        await self.Upload_Reta_Claim_Doc();
        await self.DWObject.RemoveAllImages();
      }
      if (self.selCategory && self.selCategory.CD_CODE == 2) {
        //await self.Upload();
        //await self.Notes();
        await self.DWObject.RemoveAllImages();
      } else if (self.selCategory && self.selCategory.CD_CODE == 1) {
        //await self.Upload_2();
        //await self.Notes_2();
        await self.DWObject.RemoveAllImages();
      }
    },

    /*     Find_Item_In_Category: async function (code) {
      return await this.Lst_Category.find((i) => i.CD_CODE == code);
    },

    Find_Item_In_Category: async function (code) {
      return await this.Lst_Category.find((i) => i.CD_CODE == code);
    }, */

    /*     Clear: async function () {
      await this.DWObject.RemoveAllImages();
    }, */

    Clear: async function () {
      document.getElementById("uploader").value = "";
      this.lst_file = [];
    },

    GetUser: function () {
      var self = this;
      var url = self.methodUrl + "/depdoc/WebService.asmx/GetUser";
      axios
        .post(url, {})
        .then((r) => {
          var dt = JSON.parse(r.data.d);
          if (dt) self.UserInfo = dt[0];
        })
        .catch(() => {
          self.UserInfo = null;
        });
    },

    Get_EmpInfo: async function (emp) {
      var self = this;
      await axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/Get_EmpInfo", {
          emp: emp,
        })
        .then((r) => {
          var dt = JSON.parse(r.data.d);
          if (dt) {
            var d = dt[0];
            self.Account_Number = d.ACCOUNT_NUMBER;
          }
        })
        .catch(() => {});
    },

    GetDepDocList: async function () {
      var self = this;
      await axios
        .post(self.methodUrl + "/depdoc/WebService.asmx/GetDepDocList", {
          dep_no: self.dep_no,
        })
        .then((r) => {
          var dt = JSON.parse(r.data.d);
          if (dt) {
            self.dep_doc_list = dt;
          } else {
            self.dep_doc_list = [];
          }
        })
        .catch(() => {
          self.dep_doc_list = [];
        });
    },

    Get_Dependent_List: async function (employee_number) {
      var self = this;
      await axios
        .post(
          self.methodUrl + "/depdoc/WebService.asmx/Get_Dependent_Listing",
          {
            employee_number: employee_number,
          }
        )
        .then((r) => {
          self.Lst_Dependent = JSON.parse(r.data.d);
        })
        .catch(() => {
          self.Lst_Dependent = [];
        });
    },

    async base64ToBlob(base64, mime) {
      mime = mime || "";
      var sliceSize = 1024;
      var byteChars = window.atob(base64);
      var byteArrays = [];

      for (
        var offset = 0, len = byteChars.length;
        offset < len;
        offset += sliceSize
      ) {
        var slice = byteChars.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      return new Blob(byteArrays, { type: mime });
    },

    Upload_Reta_Claim_Doc_2: async function () {
      var self = this;

      var file_name = "";

      var r = await self.Save_PDF_Reta_Claim_2(
        "PDF",
        JSON.stringify(self.lst_file),
        file_name
      );
      if (r == 1) {
        self.dgConfirm = true;
      }
    },

    Build_PDF_Filename: async function () {
      var self = this;

      var dep = "";
      if (self.selDependent) dep = self.selDependent.FULLNAME;
      else dep = "No Dependent";

      return (
        self.selCategory.DESCRIPTION +
        "_" +
        self.selCategoryItem.DESCRIPTION +
        "_" +
        dep
      );
    },

    Save_PDF_Reta_Claim_2: async function (
      report_format,
      report_file,
      filename
    ) {
      var self = this;
      var result = 0;
      if (report_file) {
        await axios
          .post(
            self.methodUrl + "/depdoc/WebService.asmx/Add_File_Reta_Claim_2",
            {
              report_format: report_format,
              report_file: report_file,
              filename: filename,
            }
          )
          .then((r) => {
            result = r.data.d;
          })
          .catch(() => {
            result = 0;
          });

        return result;
      }
    },

    Save_PDF_Reta_Claim: async function (report_format, report_file, filename) {
      var self = this;
      var result = 0;
      if (report_file) {
        await axios
          .post(
            self.methodUrl + "/depdoc/WebService.asmx/Add_File_Reta_Claim",
            {
              report_format: report_format,
              report_file: report_file,
              filename: filename,
            }
          )
          .then((r) => {
            result = r.data.d;
          })
          .catch(() => {
            result = 0;
          });

        return result;
      }
    },

    Save_PDF: async function (
      account_number,
      employee_number,
      report_type,
      report_format,
      report_file,
      file_to_blob,
      filename
    ) {
      var self = this;
      var result = 0;
      if (report_file) {
        await axios
          .post(self.methodUrl + "/depdoc/WebService.asmx/Add_File", {
            account_number: account_number,
            employee_number: employee_number,
            report_type: report_type,
            report_format: report_format,
            report_file: report_file,
            file_to_blob: file_to_blob,
            filename: filename,
          })
          .then((r) => {
            result = r.data.d;
          })
          .catch(() => {
            result = 0;
          });

        return result;
      }
    },

    Save_PDF_2: async function (
      account_number,
      employee_number,
      dependent_sequence_no,
      doc_name,
      report_file
    ) {
      var self = this;
      var result = 0;
      if (report_file) {
        await axios
          .post(self.methodUrl + "/depdoc/WebService.asmx/Add_File_2", {
            account_number: account_number,
            employee_number: employee_number,
            dependent_sequence_no: dependent_sequence_no,
            doc_name: doc_name,
            report_file: report_file,
          })
          .then((r) => {
            result = r.data.d;
          })
          .catch(() => {
            result = 0;
          });

        return result;
      }
    },

    Upload_PDF: async function (pdf, filename) {
      var self = this;
      var result = 0;
      if (pdf) {
        await axios
          .post(self.methodUrl + "/depdoc/WebService.asmx/Upload_PDF", {
            pdf: pdf,
            filename: filename,
          })
          .then((r) => {
            result = r.data.d;
          })
          .catch(() => {
            result = 0;
          });

        return result;
      }
    },

    init: async function () {
      this.loading = true;

      //await this.GetUser();
      await this.Get_EmpInfo(this.employee_number);
      await this.Get_Dependent_List(this.employee_number);
      this.loading = false;
    },
  },

  computed: {
    methodUrl() {
      return "https://www.depcertify.com";
      // return "http://localhost/web_projects";
      /*  return location.href.toLowerCase().indexOf("bastest") > -1 ||
        location.href.toLowerCase().indexOf("myenroll") > -1
        ? "/web_projects"
        : "http://localhost/web_projects"; */
    },

    ValidateFiles() {
      var self = this;
      if (
        self.lst_file &&
        self.lst_file.length > 0 &&
        self.selDependent &&
        self.selDependent != null
      ) {
        for (var i = 0; i < self.lst_file.length; i++) {
          if (self.lst_file[i].doc_type == "") return true;
        }
        return false;
      } else return true;
    },

    client_logo() {
      var self = this;

      if (self.Account_Number) {
        const first7Chars = self.Account_Number.slice(0, 7);
        return "./logo/" + first7Chars + ".jpg";
      } else return "";
    },

    employee_number: {
      get() {
        return this.$store.state.employee_number;
      },
      set(newValue) {
        this.$store.state.employee_number = newValue;
      },
    },

    rcapt_token: {
      get() {
        return this.$store.state.rcapt_token;
      },
      set(newValue) {
        this.$store.state.rcapt_token = newValue;
      },
    },
  },
};
</script>

<style scoped>
h1,
h2,
h3,
h4,
h5,
h6,
p,
li {
  font-family: "Open Sans", sans-serif;
  color: #565656;
  margin: 0px;
  padding: 0px;
}
ul,
ol,
li {
  font-family: "Open Sans", sans-serif;
  color: #565656;
}
h1 {
  font-size: 2em;
  font-weight: 700;
}
h2 {
  font-size: 1.5em;
  font-weight: 700;
}
h3 {
  font-size: 1.3em;
  font-weight: 700;
}
h4 {
  font-size: 1em;
  font-weight: 700;
}
h5 {
  font-size: 0.8em;
  font-weight: 700;
}
h6 {
  font-size: 0.7em;
  font-weight: 700;
}
p {
  font-size: 1em;
  font-weight: 500;
}
a {
  text-decoration: none;
  color: #22386e;
}
a:active {
  color: #22386e;
}

/**
* Dependent Audit Sign-in Framework styling
*
*
*/
.box-wrapper {
  max-width: 700px;
  margin: 0 auto;
  padding: 20px;
  border-radius: 3px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.2);
}
.flex-wrapper {
  display: flex;
  flex-direction: row;
  align-items: left;
}
.flex-size {
  flex: 1;
}
.text-centeralign {
  text-align: center;
}
.section-wrapper {
  max-width: 650px;
  margin: 20px auto;
  text-align: left;
}

/* SMALL SCREEN SIZING */
@media screen and (max-width: 767px) {
  .flex-wrapper {
    flex-direction: column;
  }
}

/* for DWT */
.disableTextRezie {
  resize: none !important;
}

.icon-bar {
  background-color: #323234;
  overflow: hidden;
  border: none;
}

.icon-bar a {
  float: left;
  display: block;
  color: white;
  background-color: #323234;
  text-align: center;
  padding: 8px 5px 0px 5px;
  text-decoration: none;
  cursor: default;
}

.menu1 {
  background-color: #323234;
  overflow: hidden;
}

.menu1 input {
  float: left;
  display: block;
  color: white;
  background-color: #323234;
  text-align: center;
  padding: 10px 5px 10px 5px;
  text-decoration: none;
}

.PointerMode {
  background: #323234;
  cursor: pointer !important;
}

.container {
  width: auto;
  padding-left: 0px !important;
  padding-top: 0px !important;
  padding-right: 0px !important;
  padding-bottom: 0px !important;
  margin-right: auto;
  margin-left: auto;
}
</style>
